import React from 'react';

export default class DataSummary extends React.Component {
	
  constructor(props) {
		super(props);

    const data = this.props.data || []

    this.state = {
      data: data,
      loading: data && data.length ? false : true
    }

    this.loadData = this.loadData.bind(this)        
	}

  componentDidMount() {
    if (!this.state.data || this.state.data.length === 0) {
      this.loadData()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.endpoint !== this.props.endpoint) {
      this.loadData()
    }
  }

	render() {
		// console.log(this.props)
    let data = null
    if (this.state.data && this.state.data.length) {
      data = this.state.data.map((d) => (
        <div className="category-section py-9 border border-t-0 border-l-0 border-r-0 border-b-1" key={d.name}>
          <span className="category-name md:pl-3 py-10">{d.name}</span>
          <span className="category-value md:pr-3 float-right">{d.value}</span>
        </div>
      ))
    }

		return (
			<div className="DataSummary">
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div className='md:mx-5 mt-20 lg:mt-8 border border-l-0 border-r-0 border-b-0'>
					{data}
				</div>
			</div>
		);
	}

  loadData() {
    this.setState({loading: true});
    $.ajax({
      type: 'POST',
      url: this.props.endpoint,
    }).done((data) => {
    	//console.log('DataSummary loadData done', data);
      this.setState({data: data, loading: false})
    });
  }

}
